<template>
  <div class="order-submit">
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter" @click="pageToBack"><img src="@/assets/img/appointment/back.svg" /></div>
      <div class="nav-title d-allcenter overflow">取消预约</div>
      <div class="nav-right"></div>
    </div>
    <div style="margin-top: 44px; background: #f9f9f9; padding-top: 16px">
      <div class="order-info fs-sm" style="position: relative; padding: 0; width: calc(100% - 32px)">
        <div
          style="
            position: absolute;
            width: 12px;
            height: 12px;
            background: #f9f9f9;
            border-radius: 50%;
            bottom: -6px;
            left: -6px;
          "
        ></div>
        <div
          style="
            position: absolute;
            width: 12px;
            height: 12px;
            background: #f9f9f9;
            border-radius: 50%;
            bottom: -6px;
            right: -6px;
          "
        ></div>
        <div class="info-box">
          <div class="d-aligncnter">
            <div style="width: 80px; height: 80px; border-radius: 2px; overflow: hidden" class="d-allcenter">
              <el-image style="width: 80px; height: 64px" :src="allData.venueImg" fit="cover"></el-image>
            </div>
            <div style="margin-left: 16px; font-size: 14px; width: calc(100% - 100px)">
              <div class="weight overflow2">
                {{ allData.venueName }}-{{ allData.areaName }}({{ allData.blockName }})
              </div>
              <div class="grey mt-4">{{ allData.date }} {{ allData.timeInterval }}</div>
              <div class="grey mt-4">预约人数：{{ allData.peopleNums }}</div>
            </div>
          </div>
        </div>
        <div style="padding: 16px">
          <div class="d-aligncnter d-between" v-for="(item, index) in allData.users" :key="'friend_' + index">
            <div class="fs-xs d-aligncnter">
              {{ index + 1 }}.{{ item.name }}
              <div
                v-if="item.main"
                style="color: #fff; background: #e14c46; padding: 2px 4px; border-radius: 90px; margin-left: 8px"
              >
                本人
              </div>
            </div>
            <div class="grey" style="margin-left: 16px">{{ item.mobile }}</div>
          </div>
        </div>
      </div>
      <div class="order-info fs-sm" style="margin-top: 8px">
        <div class="d-between">
          <div class="weight">退款金额</div>
          <div class="d-aligncnter grey">￥100</div>
        </div>
      </div>
      <div class="order-info fs-sm" style="margin-top: 8px">
        <div class="d-between">
          <div class="weight">申请原因</div>
          <div class="d-aligncnter grey" :class="reason ? 'font-0' : 'grey'" @click="choseReason = true">
            <div style="line-height: 16px; font-size: 14px">
              {{ reason ? reason : '点击选择申请原因' }}
            </div>
            <img
              src="@/assets/img/appointment/backgrey.svg"
              style="width: 16px; transform: rotate(180deg); margin-left: 8px"
            />
          </div>
        </div>
      </div>
      <div class="d-allcenter">
        <button class="save-btn" style="width: calc(100vw - 64px)" @click="submitCancel">
          <div>提交申请</div>
        </button>
      </div>
      <el-drawer title="取消原因" :visible.sync="choseReason" width="100%" direction="btt">
        <div
          v-for="(item, index) in reasonList"
          :key="'reason_' + index"
          style="padding: 8px 16px; border-bottom: 1px solid #ededed"
          class="font-0"
          @click="choseReasonClick(item, index)"
        >
          {{ item.name }}
        </div>
      </el-drawer>
    </div>
  </div>
</template>
<script>
import { Message, MessageBox } from 'element-ui'
import EventBus from '@/assets/js/EventBus'
import { getConferenceInfo, getReasons, refund } from '@/api/api-venueOrder'
export default {
  components: {},
  data() {
    return {
      title: '取消预约',
      allData: {},
      conferenceId: '',
      choseReason: false,
      reason: '',
      reasonList: [
        // { name: '临时有事', value: 1 },
        // { name: '行程有变', value: 2 },
        // { name: '其他原因', value: 3 },
        // { name: '临时有事', value: 1 },
        // { name: '行程有变', value: 2 },
        // { name: '其他原因', value: 3 },
      ],
      reasonIndex: -1,
    }
  },
  mounted() {
    console.log('conferenceId！！')
    this.conferenceId = this.$route.query.conferenceId
    console.log('conferenceId', this.conferenceId)
    this.getInitData()
    this.getReasonList()
  },

  computed: {},
  methods: {
    getReasonList() {
      getReasons().then((res) => {
        if (res.data.statusCode == 1) {
          this.reasonList = res.data.obj
        }
      })
    },
    getInitData() {
      getConferenceInfo(this.conferenceId).then((res) => {
        if (res.data.statusCode == 1) {
          this.allData = res.data.obj
        }
      })
    },
    pageToBack() {
      this.$router.go(-1)
    },
    drawback() {},
    copyText() {
      console.log('navigator.clipboard:', navigator.clipboard)
      if (navigator.clipboard && window.isSecureContext) {
        // navigator.clipboard
        //   .writeText('2024010212121212349')
        //   .then(() => {
        //     Message.success('复制成功')
        //   })
        //   .catch(() => {
        //     Message.error('复制失败')
        //   })
        return navigator.clipboard.writeText('123')
      } else {
        console.log('navigator.clipboard:', window.isSecureContext)
        let areaText = document.createElement('textarea')
        areaText.value = this.allData.orderNum
        areaText.style.position = 'absolute'
        areaText.style.opacity = '0'
        areaText.style.left = '0'
        areaText.style.top = '0'
        document.body.appendChild(areaText)
        areaText.focus()
        areaText.select()
        Message.success('已复制')
        return new Promise((res, rej) => {
          document.execCommand('copy') ? res() : rej()
          areaText.remove()
        })
      }
    },
    choseReasonClick(item, index) {
      this.choseReason = false
      this.reason = item.name
      this.reasonIndex = index
    },
    submitCancel() {
      if (this.reason == '') {
        Message.error('请选择取消预约原因')
      } else {
        MessageBox.confirm('确定提交取消预约吗？', '取消提示', { confirmButtonText: '确定', cancelButtonText: '取消' })
          .then(() => {
            console.log('确定取消')
            const loading = this.$loading({
              lock: true,
              text: '取消预定中',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)',
            })
            refund(this.conferenceId, this.reason).then((res) => {
              console.log('取消预约:', res)
              loading.close()
              if (res.data.statusCode == 1) {
                Message.success('已提交')
                // this.getMyConferenceData()
                // this.$emit('getMyConferenceData')
                EventBus.$emit('refreshOrderList')
                this.$router.go(-1)
              } else {
                Message.error(res.data.message)
              }
            })
          })
          .catch(() => {
            console.log('取消')
          })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';
.order-submit {
  height: calc(100vh - 44px);
  background: #f9f9f9;
}
.mt-8 {
  margin-top: 8px;
}
.pt-16 {
  padding: 16px;
}
.submit {
  background: #007a4d;
  color: #fff;
  width: 100px;
  height: 44px;
  font-size: 14px;
}
.order-line {
  width: calc(100% - 32px);
  background: #fff;
  padding: 16px;
  font-size: 14px;
}
.bottom-sub {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 44px;
  background: #fff;
  line-height: 44px;
}
.plain-btn {
  border: 1px solid #339571;
  color: #339571;
  margin-left: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  background: #fff;
}
.full-btn {
  background-color: #339571;
  color: #fff;
  border: 1px solid #339571;
  margin-left: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}
.order-info {
  border-radius: 8px;
  background: #fff;
  //   box-shadow: 0px 2px 4px 0px #e8e8e8;
  padding: 16px;
  margin: 0 16px;
  width: calc(100% - 64px);
}

.info-box {
  border-radius: 8px 8px 0 0;
  background: linear-gradient(302deg, #e6f2ed 0%, #fff8e7 100%), #fff;
  //   box-shadow: 0px 2px 4px 0px #e8e8e8;
  //   margin: 16px;
  padding: 16px;
}
.save-btn {
  border-radius: 90px;
  //   background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%);
  background: #e14c46;
  width: 343px;
  height: 48px;
  border: 1px solid #e14c46;
  color: #fff;
  font-size: 14px;
  margin-top: 16px;
  position: absolute;
  bottom: 52px;
}
.order-submit ::v-deep .el-drawer__header span {
  text-align: center;
}
.order-submit ::v-deep .el-drawer__header {
  margin-bottom: 8px;
}
</style>
